import { OrgState, RootState } from '../../types';
import { GetterTree } from 'vuex';

const getters: GetterTree<OrgState, RootState> = {
  getLogoUrl: (state: OrgState): string => {
    return state.logoUrl;
  },
  getName(state: OrgState): string {
    return state.name;
  },
  getShortName(state: OrgState): string {
    return state.shortname;
  },
};

export default getters;
